import { css as h, LitElement as v, nothing as d, html as p } from "lit";
import { property as r, customElement as g } from "lit/decorators.js";
import { b as u } from "./styles-scZ6dVz-.js";
var f = Object.defineProperty, m = Object.getOwnPropertyDescriptor, a = (c, s, o, l) => {
  for (var e = l > 1 ? void 0 : l ? m(s, o) : s, i = c.length - 1, n; i >= 0; i--)
    (n = c[i]) && (e = (l ? n(s, o, e) : n(e)) || e);
  return l && e && f(s, o, e), e;
};
let t = class extends v {
  constructor() {
    super(...arguments), this.shellTitle = "", this.subtitle = "", this.compact = !1, this.flush = !1, this.background = !1;
  }
  render() {
    return p`
      <div part="shell" class="shell">
        <div part="header" class="header">
          <div class="header-content">
            ${this.shellTitle ? p`<h1 part="title" class="title">${this.shellTitle}</h1>` : d}
            ${this.subtitle ? p`<p part="subtitle" class="subtitle">${this.subtitle}</p>` : d}
          </div>
          <div part="actions" class="actions">
            <slot name="actions"></slot>
          </div>
        </div>

        <div part="subnav" class="subnav">
          <slot name="subnav"></slot>
        </div>

        <div part="content" class="content">
          <slot></slot>
        </div>
      </div>
    `;
  }
};
t.styles = [
  u,
  h`
      :host {
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow: hidden;
      }

      .shell {
        display: flex;
        flex-direction: column;
        height: 100%;
        overflow: hidden;
      }

      .header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: var(--r5-space-4);
        padding: var(--r5-space-6);
        padding-bottom: var(--r5-space-4);
        background-color: var(--r5-bg);
        flex-shrink: 0;
      }

      .header-content {
        display: flex;
        flex-direction: column;
        gap: var(--r5-space-1);
        min-width: 0;
      }

      .title {
        font-size: var(--r5-text-2xl);
        font-weight: var(--r5-font-bold);
        color: var(--r5-text);
        line-height: var(--r5-leading-tight);
        margin: 0;
      }

      .subtitle {
        font-size: var(--r5-text-sm);
        color: var(--r5-text-muted);
        line-height: var(--r5-leading-normal);
        margin: 0;
      }

      .actions {
        display: flex;
        align-items: center;
        gap: var(--r5-space-2);
        flex-shrink: 0;
      }

      .subnav {
        padding: 0 var(--r5-space-6);
        padding-bottom: var(--r5-space-4);
        background-color: var(--r5-bg);
        flex-shrink: 0;
      }

      .subnav:empty {
        display: none;
      }

      .content {
        flex: 1;
        min-height: 0;
        overflow: auto;
        padding: var(--r5-space-6);
        padding-top: 0;
      }

      /* Variant: compact header */
      :host([compact]) .header {
        padding: var(--r5-space-4) var(--r5-space-6);
      }

      :host([compact]) .title {
        font-size: var(--r5-text-xl);
      }

      :host([compact]) .subnav {
        padding-bottom: var(--r5-space-3);
      }

      /* Variant: flush content (no padding) */
      :host([flush]) .content {
        padding: 0;
      }

      /* Variant: with background */
      :host([background]) .content {
        background-color: var(--r5-bg-muted);
        padding: var(--r5-space-6);
      }
    `
];
a([
  r({ type: String })
], t.prototype, "shellTitle", 2);
a([
  r({ type: String })
], t.prototype, "subtitle", 2);
a([
  r({ type: Boolean, reflect: !0 })
], t.prototype, "compact", 2);
a([
  r({ type: Boolean, reflect: !0 })
], t.prototype, "flush", 2);
a([
  r({ type: Boolean, reflect: !0 })
], t.prototype, "background", 2);
t = a([
  g("ark-admin-shell")
], t);
export {
  t as A
};
//# sourceMappingURL=ark-admin-shell-B4X2hshS.js.map
